import { createContext, useContext } from 'react';

export const CustomerContext = createContext(null);

export function useCustomerContext() {
    const ctx = useContext(CustomerContext);
    if (!ctx) throw new Error('useCustomerContext muss innerhalb von CustomerProvider genutzt werden');
    return ctx;
}